import http from "../redux/http";

export const getChatsAPI = async ({ size, page, search, userId }) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (search) params.search = search;

  return await http.get(`/users/${userId}/chats`, {
    params,
  });
};

export const getMessagesAPI = async ({ size, page, search, inboxId }) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (inboxId) params.inboxId = inboxId;
  if (search) params.search = search;

  return await http.get(`/messages`, {
    params,
  });
};

export const sendMessageAPI = async (body) => {
  return http.post(`/messages`, body);
};

export const deleteMessageAPI = async (id) => {
  return http.delete(`/messages/${id}`);
};

export const getUnreadMessagesAPI = async (userId) => {
  const params = {
    status: "unread",
  };

  return await http.get(`/users/${userId}/chats`, {
    params,
  });
};

export const readMessageAPI = async ({ id, body }) => {
  return http.put(`/messages/${id}`, body);
};
